export const DoubleGreenTick = () => (
  <svg
    width="22"
    height="10"
    viewBox="0 0 22 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1 5.56171L4.42857 8.92868L12.4286 1.07153"
      stroke="currentColor"
      stroke-width="1.42857"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M10.8174 6.78582L12.9995 8.92868L20.9995 1.07153"
      stroke="currentColor"
      stroke-width="1.42857"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);
